<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    item-text="name"
    item-value="pk"
    no-filter
    clearable
    outlined
    dense
    hide-details
    hide-no-data
    @focus="loadDefault"
    @input="$emit('input', $event)" />
</template>

<script>
  import { debounce } from 'lodash'

  // Liste déroulante qui cherche dans une ressource de l'API au fil de la frappe
  export default {
    name: 'RemoteSelect',
    props: {
      value: {
        type: String,
        default: null
      },
      resource: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: ''
      },
      searchParam: {
        type: String,
        default: 'searchable_name'
      },
      itemName: {
        type: Function,
        default: item => item.name
      }
    },
    data () {
      return {
        items: [],
        search: null,
        loading: false,
        defaultLoaded: false
      }
    },
    watch: {
      search (val) {
        const selected = this.items.find(i => i.pk === this.value)
        if (selected && selected.name === val) return
        this.debouncedFetch(val)
      }
    },
    created () {
      this.debouncedFetch = debounce(this.fetch, 300)
      if (this.value) {
        this.fetchSelected()
      }
    },
    methods: {
      // À l'ouverture, propose une première liste sans attendre la frappe
      loadDefault () {
        if (!this.defaultLoaded && !this.search) {
          this.defaultLoaded = true
          this.fetch(null)
        }
      },
      async fetch (query) {
        // la recherche de l'API demande au moins 2 caractères
        if (query && query.length < 2) return
        const params = { per_page: 50 }
        if (query) params[this.searchParam] = query
        this.loading = true
        try {
          const { data } = await this.$api.get(this.resource, params)
          const selected = this.items.filter(i => i.pk === this.value)
          this.items = selected.concat(data.items.map(this.toOption).filter(i => i.pk !== this.value))
        } finally {
          this.loading = false
        }
      },
      async fetchSelected () {
        const { data } = await this.$api.get(this.resource, { pk: this.value })
        this.items = data.items.map(this.toOption)
      },
      toOption (item) {
        return { pk: item.pk, name: this.itemName(item) }
      }
    }
  }
</script>
